import React, { useEffect, useState } from "react";

import { useAdminWatermarkRuleApi } from "../api/useAdminWatermarkRuleApi";
import { WatermarkRuleItem, mapToWatermarkRuleItem } from "../listing/WatermarkRuleItem";
import { WatermarkRuleContext } from "./WatermarkRuleContext";

interface WatermarkRuleProviderProps {
    children: React.ReactNode;
}

export const WatermarkRuleProvider: React.FC<WatermarkRuleProviderProps> = (props: WatermarkRuleProviderProps) => {
    const { children } = props;
    const { getWatermarkRuleList } = useAdminWatermarkRuleApi();

    const [watermarkRuleItems, setWatermarkRuleItems] = useState<WatermarkRuleItem[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        setIsLoading(true);

        getWatermarkRuleList()
            .then((response) => {
                const watermarkRules = response.items.map(mapToWatermarkRuleItem);
                setWatermarkRuleItems(watermarkRules);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    const addWatermarkRuleItem = (item: WatermarkRuleItem): void => {
        setWatermarkRuleItems((prevItems) => {
            return [item, ...prevItems];
        });
    };

    const updateWatermarkRuleItem = (item: WatermarkRuleItem): void => {
        setWatermarkRuleItems((prevItems) => {
            return prevItems.map((i) => (i.id === item?.id ? { ...item } : i));
        });
    };

    const deleteWatermarkRuleItem = (watermarkRuleId: string) => {
        setWatermarkRuleItems((prevState) =>
            prevState.filter((item: WatermarkRuleItem) => item.id !== watermarkRuleId)
        );
    };

    return (
        <WatermarkRuleContext.Provider
            value={{
                watermarkRuleItems,
                isLoading,
                setWatermarkRuleItems,
                addWatermarkRuleItem,
                deleteWatermarkRuleItem,
                updateWatermarkRuleItem
            }}
        >
            {children}
        </WatermarkRuleContext.Provider>
    );
};
